module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-how-we-teach-a55bdf4a68d3deb2f74fa4c30a2529fa.webp";